export const COMMISSION_DATA_INTERNAL = {
  ARLA: {
    first_range: {
      min: 0,
      max: 5,
      indice: 0.015,
    },
    second_range: {
      min: 5,
      max: 15,
      indice: 0.03,
    },
    third_range: {
      min: 15,
      max: 100,
      indice: 0.05,
    },
  },
  DIESEL: {
    first_range: {
      min: 0,
      max: 3.5,
      indice: 0.0017,
    },
    second_range: {
      min: 3.51,
      max: 5.5,
      indice: 0.0021,
    },
    third_range: {
      min: 5.51,
      max: 7,
      indice: 0.003,
    },
    fourth_range: {
      min: 7.01,
      max: 1000,
      indice: 0.0035,
    },
  },
};

export const COMMISSION_DATA_EXTERNAL = {
  ARLA: {
    first_range: {
      min: 0,
      max: 5,
      indice: 0.015,
    },
    second_range: {
      min: 5,
      max: 15,
      indice: 0.03,
    },
    third_range: {
      min: 15,
      max: 100,
      indice: 0.05,
    },
  },
  DIESEL: {
    first_range: {
      min: 0,
      max: 3.5,
      indice: 0.013,
    },
    second_range: {
      min: 3.51,
      max: 5.5,
      indice: 0.018,
    },
    third_range: {
      min: 5.51,
      max: 7,
      indice: 0.022,
    },
    fourth_range: {
      min: 7.01,
      max: 1000,
      indice: 0.025,
    },
  },
};
